/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedNullSearchRelatedItems_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user" | "SbSharedNullSearchRelatedItemsFollow_user">;
    readonly " $refType": "SbSharedNullSearchRelatedItems_user";
};
export type SbSharedNullSearchRelatedItems_user$data = SbSharedNullSearchRelatedItems_user;
export type SbSharedNullSearchRelatedItems_user$key = {
    readonly " $data"?: SbSharedNullSearchRelatedItems_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedNullSearchRelatedItems_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedNullSearchRelatedItems_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItemsFollow_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'de5024cff24e25e65909b4f3f15bcdb4';
export default node;
